<template>
  <div>
    <PageAllow controller="Purchases" action="getIntelligentPurchaseDetails" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card v-show="!preview">
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer />
          <v-btn
            v-if="$permission.permissionAllow('Purchases', 'addViews')"
            small
            :disabled="!doPreviewFlg"
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doPreview()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("PurchasesDetail.actions.previewSubmit") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <div v-for="(purchase, index) in purchases" :key="index">
          <v-data-table
            :headers="detailsHeaders"
            :items="purchase.purchase_details"
            disable-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
            v-if="purchase.purchase_details.length"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ purchase.stock.name }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </template>
            <!-- 规格 -->
            <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
              <span v-else>
              {{ item.standard_name ? item.standard_name : "" }}
            </span>
            </template>
            <!-- 采购订货数 -->
            <template v-slot:item.quantity="{ item }">
              <span
                v-if="
                  item.intelligentSupplier &&
                  item.intelligentSupplier.supplier_price
                "
              >
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.quantity"
                  type="number"
                  min="0"
                  @blur="
                    item.quantity = $numberFormatter.formatWithDotNoMoreThan(
                      Number(item.quantity),
                      2
                    );
                    figureUpDefaultQuantity(item);
                  "
                  style="max-width: 100px; margin-left: auto"
                >
                  <template v-if="!locale" v-slot:append>
                    <span>
                      {{ item.intelligentSupplier.purchase_unit }}
                    </span>
                  </template>
                </v-text-field>
                <span v-if="locale" class="pt-n1 text-no-wrap caption">
                  {{ item.intelligentSupplier.purchase_unit }}
                </span>
              </span>
              <span v-else>
                <v-btn
                  color="primary"
                  @click.stop="
                    supplierBindDialog = true;
                    currentItem = item.intelligentSupplier;
                    currentMaterial = item;
                  "
                  small
                  outlined
                  >{{ $t("PurchasesList.intelligent.bind") }}</v-btn
                >
              </span>
            </template>
            <!-- 基准 -->
            <template v-slot:item.default_quantity="{ item }">
              <span>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.purchase_num"
                  type="number"
                  min="0"
                  @blur="
                    item.purchase_num =
                      $numberFormatter.formatWithDotNoMoreThan(
                        Number(item.purchase_num),
                        2
                      );
                    figureUpQuantity(item);
                  "
                  style="max-width: 100px; margin-left: auto"
                  :disabled="!item.quantity"
                >
                  <template v-if="!locale" v-slot:append>
                    <span>
                      {{ item.default_unit }}
                    </span>
                  </template>
                </v-text-field>
                <span v-if="locale" class="pt-n1 text-no-wrap caption">
                  {{ item.default_unit }}
                </span>
              </span>
            </template>
            <!-- 单价 -->
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money")
              }}{{
                item.intelligentSupplier
                  ? item.intelligentSupplier.supplier_price
                  : "" | formatMoney
              }}
            </template>
            <!-- 小计 -->
            <template v-slot:item.total="{ item }">
              {{ $t("Global.money") }}{{ item.total | formatMoney }}
            </template>
            <!-- 操作 -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  purchase.purchase_details.splice(
                    purchase.purchase_details.findIndex(
                      (e) => item.material_id == e.material_id
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-divider />
              <v-row no-gutters class="pt-2 pb-4">
                <!-- <v-spacer /> -->
                <!-- 供应商 -->
                <v-col cols="12" md="4">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="secondary--text">
                        {{ $t("PurchasesList.intelligent.supplier") }}
                        {{ $t("Global.colon") }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-content>
                      <SearcherSupplier
                        v-model="purchase.supplierSelected"
                        noLabel
                        unclearable
                        dense
                        @change="updateItem"
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <!-- 期望配送日期 -->
                <v-col cols="12" md="4">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="secondary--text">
                        {{ $t("PurchasesDetail.Fields.expect_date") }}
                        {{ $t("Global.colon") }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-content class="align-end text-end">
                      <SearcherDatetime
                        class="my-n2"
                        v-model="purchase.hope_delivery_date"
                        type="datetime"
                        single-line
                        dense
                        hide-details
                        disabled-before-today
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <!-- 总计 -->
                <v-col cols="12" md="4">
                  <v-list-item>
                    <v-list-item-content>
                      <span class="secondary--text font-weight-bold">
                        {{ $t("PurchasesList.intelligent.sum") }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-content>
                      <span class="accent--text font-weight-bold">
                        {{ $t("Global.money")
                        }}{{ purchase.total_price | formatMoney }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </v-card>
      <v-card v-show="preview">
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer />
          <v-btn
            v-if="$permission.permissionAllow('Purchases', 'add')"
            small
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doSubmit()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("PurchasesDetail.actions.submit") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-data-table
          :headers="detailsHeaders"
          :items="purchase.purchase_details"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
          v-for="(purchase, index) in purchasesPreview"
          :key="index"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2 pt-1">
                {{ $t("PurchasesList.intelligent.purchasesList", [index + 1]) }}

                <br />
                <span class="text-subtitle-2">
                  {{ purchase.stock ? purchase.stock.name : "" }}
                </span>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
          </template>
          <!-- 商品名称 -->
          <template v-slot:item.material_name="{ item }">
            {{ item.material ? item.material.material_name : "" }}
          </template>
          <!-- 规格 -->
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard && item.standard.name && item.standard.name.length > 12" :title="item.standard.name" style="cursor: pointer">
              {{ item.standard.name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard ? item.standard.name : "" }}
            </span>
          </template>
          <!-- 采购订货数 -->
          <template v-slot:item.quantity="{ item }">
            {{ item.quantity | formatWithDotNoMoreThan }}
          </template>
          <!-- 基准 -->
          <template v-slot:item.default_quantity="{ item }">
            {{ item.default_quantity | formatWithDotNoMoreThan }}
          </template>
          <!-- 单价 -->
          <template v-slot:item.price="{ item }">
            {{ $t("Global.money") }}{{ item.price }}
          </template>
          <!-- 小计 -->
          <template v-slot:item.total="{ item }">
            {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
          </template>
          <template v-slot:footer>
            <v-divider />
            <v-row no-gutters class="pt-2 pb-4">
              <!-- <v-spacer /> -->
              <!-- 供应商 -->
              <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <span class="secondary--text">
                      {{ $t("PurchasesList.intelligent.supplier") }}
                      {{ $t("Global.colon") }}
                    </span>
                  </v-list-item-content>
                  <v-list-item-content>
                    {{
                      purchase.supplier ? purchase.supplier.supplier_name : ""
                    }}
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <!-- 期望配送日期 -->
              <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <span class="secondary--text">
                      {{ $t("PurchasesDetail.Fields.expect_date") }}
                      {{ $t("Global.colon") }}
                    </span>
                  </v-list-item-content>
                  <v-list-item-content class="align-end text-end">
                    {{ purchase.hope_delivery_date | formatDate }}
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <!-- 总计 -->
              <v-col cols="12" md="4">
                <v-list-item>
                  <v-list-item-content>
                    <span class="secondary--text font-weight-bold">
                      {{ $t("PurchasesList.intelligent.sum") }}
                    </span>
                  </v-list-item-content>
                  <v-list-item-content>
                    <span class="accent--text font-weight-bold">
                      {{ $t("Global.money")
                      }}{{ purchase.total_price | formatMoney }}
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-sheet>
    <SupplierBindDialog
      v-model="supplierBindDialog"
      :supplier="currentItem"
      :material="currentMaterial"
      @refresh="updateItem()"
    />
    <v-dialog v-model="noPurchase" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $router.push('/intelligent-purchase');
                "
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="px-4 py-8 text-center subtitle-1 red--text font-weight-bold"
        >
          {{ $t("PurchasesList.intelligent.noPurchase") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="
              $router.push('/intelligent-purchase');
            "
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            @click.stop="
              $router.push('/intelligent-purchase/purchase-from-order')
            "
            color="primary"
          >
            {{ $t("PurchasesList.intelligent.jump") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Purchases from "@/api/purchases";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SupplierMaterials from "@/api/supplier_materials";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import SupplierBindDialog from "./plugins/supplierBindDialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    SearcherSupplier,
    SupplierBindDialog,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.intelligentPurchase"),
          disabled: false,
          href: "/intelligent-purchase",
        },
        {
          text: i18n.t("PurchasesList.intelligent.purchasesCreate"),
          disabled: true,
          href: "",
        },
      ];
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        //   采购订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "center",
          sortable: false,
          value: "quantity",
        },
        //   基准订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_quantity"),
          align: "end",
          sortable: false,
          value: "default_quantity",
        },
        // 单价
        {
          text: i18n.t("PurchasesDetail.purchaseFields.price"),
          align: "end",
          sortable: false,
          value: "price",
        },
        // 小计
        {
          text: i18n.t("PurchasesDetail.purchaseFields.sum"),
          align: "end",
          sortable: false,
          value: "total",
        },
      ];
      if (!this.preview) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "end",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    purchases: [],
    supplierSelected: {},
    noPurchase: false,
    supplierBindDialog: false,
    currentItem: {},
    currentMaterial: {},
    doPreviewFlg: false,
    purchasesPreview: [],
    preview: false,
  }),

  mounted() {
    this.getIntelligentPurchaseDetails();
  },

  methods: {
    getIntelligentPurchaseDetails() {
      var data = {};
      if (this.$route.query.type != 4) {
        data = Object.assign({}, data, {
          type: this.$route.query.type,
          stock_ids: this.$route.query.stock_ids,
        });
      } else if (this.$route.query.type == 4) {
        data = Object.assign({}, data, {
          order_ids: this.$route.query.order_ids,
          type: this.$route.query.type,
          minus_current_count: this.$route.query.minus_current_count
        });
      }
      Purchases.fetchIntelligentDetails(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchases = response.data.purchases;
            this.doPreviewFlg = true;
            if (!this.purchases.length) {
              this.noPurchase = true;
            }
          }
        }.bind(this)
      );
    },
    updateItem() {
      this.purchases.forEach((p) => {
        if (p.supplierSelected) {
          var material_ids = p.purchase_details.map((material) => {
            return material.material_id;
          });
          SupplierMaterials.fetchIntelligentProduct({
            material_ids: material_ids,
            stock_id: p.stock.id,
          }).then(function (response) {
            if (response.data.status.isOK()) {
              var materials = response.data.materials;
              materials.forEach((item) => {
                p.purchase_details.forEach((material, i) => {
                  if (material.material_id == item.id) {
                    var supplier = item.suppliers.find((supplier) => {
                      return supplier.id == p.supplierSelected.id;
                    });
                    p.purchase_details.splice(
                      i,
                      1,
                      Object.assign({}, material, {
                        intelligentSupplier: supplier,
                        standard_details: item.standard.standard_details,
                        supply_standard_detail_id:
                          item.supply_standard_detail_id,
                        quantity:
                          supplier && supplier.supplier_price
                            ? material.purchase_num
                            : null,
                      })
                    );
                  }
                });
              });
            }
          });
        }
      });
    },
    figureUpDefaultQuantity(material) {
      if (material.intelligentSupplier) {
        let purchase_standar_detail = material.standard_details.find(
          (s) => s.id == material.supply_standard_detail_id
        );
        material.purchase_num =
          Number(material.quantity) * Number(purchase_standar_detail.rate);

        //算小计金额
        if (material.intelligentSupplier.supplier_price) {
          material.total =
            Number(material.quantity) *
            Number(material.intelligentSupplier.supplier_price);
        }
      }
    },
    figureUpQuantity(material) {
      if (material.intelligentSupplier) {
        let purchase_standar_detail = material.standard_details.find(
          (s) => s.id == material.supply_standard_detail_id
        );
        if (purchase_standar_detail && purchase_standar_detail.rate) {
          if (
            Number(material.purchase_num) % Number(purchase_standar_detail.rate)
          ) {
            material.quantity = Number(
              this.$numberFormatter.formatTwoDot(
                Number(material.purchase_num) /
                  Number(purchase_standar_detail.rate)
              )
            );
          } else {
            material.quantity =
              Number(material.purchase_num) /
              Number(purchase_standar_detail.rate);
          }
          //计算小计金额
          if (material.intelligentSupplier.supplier_price) {
            material.total =
              Number(material.quantity) *
              Number(material.intelligentSupplier.supplier_price);
          }
        }
      }
    },
    updateItemTotalPrice() {
      // 计算小计金额
      this.purchases.forEach((p) => {
        var sum = 0;
        p.purchase_details.forEach((material) => {
          //计算小计金额
          if (
            material.intelligentSupplier &&
            material.intelligentSupplier.supplier_price
          ) {
            material.total =
              Number(material.quantity) *
              Number(material.intelligentSupplier.supplier_price);
            sum += material.total;
          }
        });
        p.total_price = sum;
      });
    },
    //整理预览提交数据
    doPreviewData() {
      var purchases = [];
      this.purchases.forEach((p) => {
        if (p.purchase_details.length) {
          let purchase = {
            stock_id: p.stock.id,
            hope_delivery_date: p.hope_delivery_date,
            purchase_details: [],
          };

          p.purchase_details.forEach((detail) => {
            purchase.purchase_details.push({
              material_code: detail.material_code,
              supplier_id: detail.intelligentSupplier
                ? detail.intelligentSupplier.id
                : null,
              quantity: detail.quantity ? detail.quantity : null,
              price: detail.intelligentSupplier
                ? detail.intelligentSupplier.supplier_price
                : null,
              order_detail_ids: detail.order_detail_ids ? detail.order_detail_ids : [],
              out_detail_ids: detail.out_detail_ids ? detail.out_detail_ids : []
            });
          });
          purchases.push(purchase);
        }
      });
      return purchases;
    },
    //添加预览
    doPreview() {
      var data = this.doPreviewData();
      var dateNull = null;
      if (data.length) {
        data.forEach((p) => {
          if (!p.hope_delivery_date) {
            dateNull += 1;
          }
        });
      }

      if (dateNull) {
        this.$snackbar.error(
          i18n.t("PurchasesDetail.Messages.expectDistributionDateNull")
        );
      } else if (!data.length) {
        this.$snackbar.error(i18n.t("PurchasesDetail.Messages.dataNull"));
      } else {
        Purchases.addIntelligentPreview(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.preview = true;
              this.purchasesPreview = response.data.purchases;
            }
          }.bind(this)
        );
      }
    },
    //整理预览提交数据
    doSubmitData() {
      let purchases = this.purchasesPreview.map((p) => {
        let purchase = {
          stock_id: p.stock_id,
          hope_delivery_date: p.hope_delivery_date,
          supplier_id: p.supplier_id,
          purchase_details: [],
        };

        p.purchase_details.forEach((detail) => {
          purchase.purchase_details.push({
            material_code: detail.material_code,
            quantity: detail.quantity ? detail.quantity : null,
            price: detail.price,
            order_detail_ids: detail.order_detail_ids ? detail.order_detail_ids : [],
            out_detail_ids: detail.out_detail_ids ? detail.out_detail_ids : []
          });
        });
        return purchase;
      });
      return purchases;
    },

    doSubmit() {
      Purchases.addIntelligent(this.doSubmitData())
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/purchases");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    purchases: {
      deep: true,
      handler() {
        // 计算小计金额
        this.purchases.forEach((p) => {
          var sum = 0;
          p.purchase_details.forEach((material) => {
            //计算小计金额
            if (
              material.intelligentSupplier &&
              material.intelligentSupplier.supplier_price
            ) {
              material.total =
                Number(material.quantity) *
                Number(material.intelligentSupplier.supplier_price);
              sum += material.total;
            } else {
              material.total = 0;
              sum += material.total;
            }
          });
          p.total_price = sum;
        });
      },
    },
  },
};
</script>